import * as React from 'react';

import ErrorBoundary from '@components/ErrorBoundary';
import { ICampaign } from '@containers/ProductListing/model';

import messages from '../../../messages';
import { useProductDetailContext } from '../../ProductDetailContext';
import { GiftBase } from '../ProductGifts/GiftBase/GiftBase';

interface IGiftProps {
  campaigns?: ICampaign[];
  shouldRender: boolean;
  isDiorProduct?: boolean;
}

export const Gift: React.FC<IGiftProps> = React.memo(
  ({ campaigns, shouldRender, isDiorProduct }) => {
    const { currentVariant } = useProductDetailContext();

    if (!shouldRender || !Array.isArray(campaigns) || campaigns.length === 0) {
      return null;
    }

    const filteredCampaigns = campaigns.filter(
      (campaign) =>
        campaign.displayOnDetailPage &&
        currentVariant.webId === campaign.productId &&
        (campaign.detailPageText || campaign.text)
    );

    if (filteredCampaigns.length === 0) {
      return null;
    }

    const titleMessage =
      filteredCampaigns.length > 1 ? messages.giftsForYou : messages.giftForYou;

    const filteredCampaignsForDior = [filteredCampaigns[0]];

    return (
      <ErrorBoundary>
        <GiftBase
          containerId="pdGift"
          titleMessage={titleMessage}
          imageMessage={messages.giftForYou}
          campaigns={
            isDiorProduct ? filteredCampaignsForDior : filteredCampaigns
          }
        />
      </ErrorBoundary>
    );
  }
);
